import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";

import * as formatter from "../../../../config/formatter";
import * as commonUtil from "../../../../config/common";
import * as o2Api from "../../../../api/api";
import "src/scss/grid-styles.scss";
import {Loading} from "../../../../components/common";
import {gridColumnAvg, gridColumnSum} from "../../../../config/common";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";

const CurrentSale = (props) => {
	const statGridRef = useRef();
	const currentGridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);

	const [pos, setPos] = useState([{deviceId: "전체"}]);
	const [currentSaleStatData, setCurrentSaleStatData] = useState([]);
	const [currentSaleData, setCurrentSaleData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({
		deviceId: "전체",
		saleDt: dayjs()
	});

	const defaultColDef = {
		flex: 1,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [statsColumnDefs] = useState([
		{field: "no", headerName: "No", maxWidth: 50, valueGetter: "node.rowIndex + 1"},
		{field: "tradeTypeNm", headerName: "구분", maxWidth: 60, cellClass: "static-cell"},
		{
			field: "saleAmt",
			headerName: "총매출액",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "vaultAmt",
			headerName: "실매출액",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "netAmt", headerName: "가액", valueGetter: (e) => {
				return e.data.vaultAmt - e.data.payAmtVat;
			}, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"
		},
		{
			field: "payAmtVat",
			headerName: "부가세",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "billCnt",
			headerName: "영수건수",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "payAmt", headerName: "결제합계", valueGetter: (e) => {
				return e.data.cashAmt + e.data.cardAmt;
			}, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"
		},
		{
			field: "cashAmt",
			headerName: "현금영수",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "cardAmt",
			headerName: "신용카드",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "custCnt",
			headerName: "객수",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "custTransAmt",
			headerName: "객단가",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		}
	]);

	const [statTotalRowData] = useState([
		{no: 0, tradeTypeNm: "합계"}
	])

	const createStatTotalRowData = (data) => {
		const api = statGridRef.current.api;
		const result = [];
		result.push({
			tradeTypeNm: "합계",
			saleAmt: gridColumnSum(data, 'saleAmt'),
			vaultAmt: gridColumnSum(data, 'vaultAmt'),
			netAmt: gridColumnSum(data, 'netAmt'),
			payAmtVat: gridColumnSum(data, 'payAmtVat'),
			billCnt: gridColumnSum(data, 'billCnt'),
			payAmt: gridColumnSum(data, 'payAmt'),
			cashAmt: gridColumnSum(data, 'cashAmt'),
			cardAmt: gridColumnSum(data, 'cardAmt'),
			custCnt: gridColumnSum(data, 'custCnt'),
			custTransAmt: gridColumnAvg(data, 'custTransAmt'),

		});
		api.setPinnedBottomRowData(result);
	};

	const [currentColumnDefs] = useState([
		{field: "no", headerName: "No", maxWidth: 50, valueGetter: "node.rowIndex + 1"},
		{field: "posCd", headerName: "포스\n번호", minWidth: 60, cellClass: "static-cell"},
		{
			field: "billNo",
			headerName: "영수증\n번호",
			minWidth: 80,
			cellClass: "static-cell",
			cellStyle: {color: "blue", cursor: "pointer"}
		},
		{field: "erestBillNo", headerName: "E-휴게소\n영수증번호", minWidth: 90, cellClass: "static-cell"},
		{
			field: "saleTime",
			headerName: "결제시각",
			minWidth: 80,
			valueFormatter: (e) => formatter.timeFormatter(e, "YYYYMMDDHHmmss", "HH:mm:ss"),
			cellClass: "static-cell"
		},
		{
			field: "tradeTypeNm",
			headerName: "구분",
			minWidth: 60,
			cellClass: "static-cell",
			cellStyle: (e) => {
				return (e.value === "정상" ? {color: "blue"} : {color: "red"})
			}
		},
		{
			field: "saleAmt",
			headerName: "총매출액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "payAmt",
			headerName: "실매출액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "netAmt",
			headerName: "가액",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "payAmtVat",
			headerName: "부가세",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "totalPayAmt",
			headerName: "결제합계", valueGetter: (e) => {
				return e.data.cashAmt + e.data.cardAmt;
			}, minWidth: 80, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"
		},
		{
			field: "cashAmt",
			headerName: "현금영수",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell",
			cellStyle: (e) => {
				if (e.value > 0) {
					return {color: "blue", cursor: "pointer"};
				}
				return null;
			}
		},
		{
			field: "cardAmt",
			headerName: "신용카드",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell",
			cellStyle: (e) => {
				if (e.value > 0) {
					return {color: "blue", cursor: "pointer"};
				}
				return null;
			}
		},
		{
			field: "saleTime",
			headerName: "최초\n주문시각",
			minWidth: 80,
			valueFormatter: (e) => formatter.timeFormatter(e, "YYYYMMDDHHmmss", "HH:mm:ss"),
			cellClass: "static-cell"
		},
		{
			field: "custCnt",
			headerName: "객수",
			minWidth: 60,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "custTransAmt",
			headerName: "객단가",
			minWidth: 80,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		}
	]);

	const [currentTotalRowData] = useState([
		{posCd: "합계"}
	])

	const createCurrentTotalRowData = (data) => {
		const api = currentGridRef.current.api;
		const result = [];
		result.push({
			posCd: "합계",
			saleAmt: gridColumnSum(data, 'saleAmt'),
			vaultAmt: gridColumnSum(data, 'vaultAmt'),
			netAmt: gridColumnSum(data, 'netAmt'),
			payAmtVat: gridColumnSum(data, 'payAmtVat'),
			payAmt: gridColumnSum(data, 'payAmt'),
			cashAmt: gridColumnSum(data, 'cashAmt'),
			cardAmt: gridColumnSum(data, 'cardAmt'),
			custCnt: gridColumnSum(data, 'custCnt'),
			custTransAmt: gridColumnAvg(data, 'custTransAmt'),

		});
		api.setPinnedBottomRowData(result);
	};

	useEffect(() => {
		if (props.selected.storeCd.length > 0) {
			getStoreDevice();
		}
	}, [props.selected.storeCd]);

	const getStoreDevice = () => {
		const {cmpCd, brandCd, storeCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			useYn: "Y"
		};
		setLoading(true);
		o2Api.getStoreDevice(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				// 성공
				setPos([{deviceId: "전체"}]);
				setPos((state) => state.concat(responseBody));

				setLoading(false);
			}
		});
	};

	const search = () => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd} = props.selected;
		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
			saleDt: searchForm.saleDt.format("YYYYMMDD")
		};

		setLoading(true);
		o2Api.getCurrentDayStats(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				console.log("stat : ", responseBody);

				setLoading(false);
				setCurrentSaleStatData(responseBody);
				createStatTotalRowData(responseBody);

				getCurrentDay();
			}
		});
	};

	const getCurrentDay = () => {
		const {cmpCd, brandCd, storeCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
			saleDt: searchForm.saleDt.format("YYYYMMDD")
		};

		setLoading(true);
		o2Api.getCurrentDay(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				console.log("result : ", responseBody);

				setLoading(false);
				setCurrentSaleData(responseBody);

				createCurrentTotalRowData(responseBody);
			}
		});
	};

	const onCellClicked = (e) => {
		switch (e.colDef.field) {
			case "billNo":
				onDetail(e.data);
				break;
			case "tradeTypeNm":
				console.log(e.value);
				break;
			case "cashAmt":
				if (e.value > 0) {
					window.open('/#/sale/detail/pay?seq=' + e.data.seq + '&type=cash', "_pay", "width=800, height=400");
				}
				break;
			case "cardAmt":
				if (e.value > 0) {
					window.open('/#/sale/detail/pay?seq=' + e.data.seq + '&type=card', "_pay", "width=800, height=400");
				}
				break;
		}
	};

	const onDetail = (data) => {
		if (data.seq !== undefined && data.seq !== null) {
			console.log("data : ", data);
			const params = "seq=" + data.seq;
			window.open("/#/sale/detail?" + params, "_detail", "width=800, height=600");
		}
	};

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				brandCd: code
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				storeCd: code
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cornerCd: code
			}));
		}
	};

	return (

		<div style={containerStyle}>
			{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
			<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
				<h5>당일-매출상세</h5>
				<CButton color="dark" onClick={search}>조회</CButton>
			</div>
			<CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
				<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
									  onSelect={(c, v) => handleSelect(c, v)}/>
				<CCol xs={12}>
					<CInputGroup size={"sm"}>
						<CInputGroupText style={{width: 100}}>조회일자</CInputGroupText>
						<CInputGroupText style={{background: "white", height: 35}}>
							<DatePicker bordered={false}
										separator={"~"}
										placeholder={""}
										locale={locale}
										value={searchForm.saleDt}
										onChange={(dayjs, dateString) => {
											setSearchForm((state) => ({
												...state, saleDt: dayjs
											}));
										}}/>
						</CInputGroupText>
					</CInputGroup>
				</CCol>
				<CCol xs={12}>
					<CInputGroup size={"sm"}>
						<CInputGroupText style={{width: 100}}>포스번호</CInputGroupText>
						<CFormSelect value={searchForm.deviceId}
									 onChange={(e) => {
										 setSearchForm((state) => ({
											 ...state,
											 deviceId: e.target.value
										 }));
									 }}
						>
							{pos.map((p, index) => {
								return (
									<option key={index} value={p.deviceId}>{p.deviceId}</option>
								);
							})}
						</CFormSelect>
					</CInputGroup>
				</CCol>
			</CForm>

			<div style={{height: 10}}/>
			<div>
				<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
					당일매출 집계내역 (실매출액 = 총매출액 - 총할인액, 결제합계 = 가액 + 부가세)
				</div>
				<div className="ag-theme-alpine" style={{width: "100%", height: 125, marginTop: 10}}>
					<AgGridReact
						ref={statGridRef}
						headerHeight={30}
						rowHeight={30}
						rowData={currentSaleStatData}
						localeText={{noRowsToShow: "조회 결과가 없습니다."}}
						animateRows={true}
						pinnedBottomRowData={statTotalRowData}
						defaultColDef={defaultColDef}
						columnDefs={statsColumnDefs}>
					</AgGridReact>
				</div>
				<div style={{height: 10}}/>
				<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
					당일매출 상세내역 (실매출액 = 총매출액 - 총할인액, 결제합계 = 가액 + 부가세)
				</div>
				<div className="ag-theme-alpine" style={{width: "100%", height: 320, marginTop: 10}}>
					<AgGridReact
						ref={currentGridRef}
						onCellClicked={onCellClicked}
						headerHeight={30}
						rowHeight={30}
						rowData={currentSaleData}
						enableRangeSelection={true}
						enableCellTextSelection={true}
						suppressClipboardPaste={true}
						localeText={{noRowsToShow: "조회 결과가 없습니다."}}
						animateRows={true}
						pinnedBottomRowData={currentTotalRowData}
						defaultColDef={defaultColDef}
						columnDefs={currentColumnDefs}>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(CurrentSale);
